import { useEffect, useState } from "react";
import { LANDING } from "@/constants/testIds";
/* eslint-disable react/no-unescaped-entities */

const LINKS = [
  { href: "/", label: "Home" },
  { href: "/our-story", label: "Our Story" },
  { href: "/partner-benefits", label: "Partner Benefits" },
  { href: "/diwali-collection", label: "Diwali Gifts" },
  { href: "/give-back", label: "Green Gift" },
];

export default function Nav({ onBookMeeting }) {
  const [open, setOpen] = useState(false);

  // Lock body scroll while the mobile drawer is open
  useEffect(() => {
    if (open) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => { document.body.style.overflow = prev; };
    }
  }, [open]);

  // Close on Escape
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  const closeAndBook = () => {
    setOpen(false);
    onBookMeeting?.();
  };

  return (
    <>
      <nav className="utsah-nav">
        <a href="/" className="nav-logo" data-testid={LANDING.navLogo} aria-label="Utsah — home"><img src="/brand/utsah-logo.png" alt="Utsah" className="nav-logo-img" /></a>

        {/* Desktop links */}
        <ul className="nav-links">
          {LINKS.map((l) => (
            <li key={l.href}><a href={l.href}>{l.label}</a></li>
          ))}
          <li>
            <button
              className="nav-cta"
              data-testid={LANDING.navBookMeeting}
              onClick={onBookMeeting}
            >
              Speak to a Gift Advisor
            </button>
          </li>
        </ul>

        {/* Mobile hamburger — visible only ≤960px */}
        <button
          type="button"
          className={`nav-hamburger ${open ? "open" : ""}`.trim()}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          data-testid="nav-hamburger"
          onClick={() => setOpen((v) => !v)}
        >
          <span /><span /><span />
        </button>
      </nav>

      {/* Backdrop — sibling of nav so `position: fixed` is relative to viewport
          (nav's backdrop-filter would otherwise trap descendants inside 76px). */}
      <div
        className={`nav-mobile-backdrop ${open ? "open" : ""}`.trim()}
        aria-hidden
        onClick={() => setOpen(false)}
      />

      {/* Mobile drawer — also a sibling of nav */}
      <aside
        className={`nav-mobile-drawer ${open ? "open" : ""}`.trim()}
        aria-hidden={!open}
        role="dialog"
        aria-modal="true"
        aria-label="Site navigation"
        data-testid="nav-mobile-drawer"
      >
        <div className="nav-mobile-header">
          <a href="/" className="nav-logo" aria-label="Utsah — home"><img src="/brand/utsah-logo.png" alt="Utsah" className="nav-logo-img" /></a>
          <button
            type="button"
            className="nav-mobile-close"
            aria-label="Close menu"
            data-testid="nav-mobile-close"
            onClick={() => setOpen(false)}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden>
              <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        <ul className="nav-mobile-links">
          {LINKS.map((l) => (
            <li key={l.href}>
              <a
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <span className="nav-mobile-link-arrow" aria-hidden>→</span>
                {l.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="nav-mobile-cta-wrap">
          <button
            className="nav-mobile-cta"
            onClick={closeAndBook}
            data-testid="nav-mobile-book-meeting"
          >
            Speak to a Gift Advisor
            <svg width="16" height="12" viewBox="0 0 18 12" fill="none" aria-hidden>
              <path d="M1 6h15M11 1l5 5-5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
          <a
            className="nav-mobile-whatsapp"
            href="https://wa.me/917208286283"
            target="_blank"
            rel="noreferrer noopener"
            data-testid="nav-mobile-whatsapp"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347M12.05 21.785h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884" />
            </svg>
            Chat on WhatsApp
          </a>
        </div>

        <div className="nav-mobile-footnote">
          A gift that keeps growing, long after it's opened.
        </div>
      </aside>
    </>
  );
}
